import React from "react";
import "./commonComponents.scss";

function BlockingOverlay() {
  return <div className="blockingOverlay" />;
}

export default BlockingOverlay;
